import React from "react";

/**
 * Light white/blue login visual (no text). Used when admin festival banner is empty.
 */
const LoginVisualSvg = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 960 1080"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden
  >
    <defs>
      <linearGradient id="authBgLight" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="50%" stopColor="#f7f9ff" />
        <stop offset="100%" stopColor="#e8efff" />
      </linearGradient>
      <linearGradient id="authSoftBlue" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#02026E" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="cardFaceLight" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="100%" stopColor="#eef3ff" />
      </linearGradient>
    </defs>

    <rect width="960" height="1080" fill="url(#authBgLight)" />
    <circle cx="80" cy="140" r="260" fill="url(#authSoftBlue)" />
    <circle
      cx="860"
      cy="980"
      r="300"
      fill="var(--primary-color, #02026E)"
      fillOpacity="0.06"
    />
    <circle
      cx="720"
      cy="120"
      r="110"
      fill="var(--primary-color, #02026E)"
      fillOpacity="0.05"
    />

    {/* Soft wallet / card stack */}
    <g transform="translate(210 280)">
      <rect
        x="40"
        y="120"
        width="420"
        height="260"
        rx="28"
        fill="var(--primary-color, #02026E)"
        fillOpacity="0.06"
      />
      <rect
        x="70"
        y="80"
        width="420"
        height="260"
        rx="28"
        fill="url(#cardFaceLight)"
        stroke="var(--primary-color, #02026E)"
        strokeOpacity="0.18"
        strokeWidth="2"
      />
      <rect
        x="100"
        y="40"
        width="420"
        height="260"
        rx="28"
        fill="#ffffff"
        stroke="var(--primary-color, #02026E)"
        strokeOpacity="0.22"
        strokeWidth="2"
      />
      <rect
        x="140"
        y="100"
        width="120"
        height="78"
        rx="12"
        fill="var(--primary-color, #02026E)"
        fillOpacity="0.12"
      />
      <rect
        x="140"
        y="210"
        width="220"
        height="16"
        rx="8"
        fill="var(--primary-color, #02026E)"
        fillOpacity="0.14"
      />
      <rect
        x="140"
        y="242"
        width="150"
        height="14"
        rx="7"
        fill="var(--primary-color, #02026E)"
        fillOpacity="0.08"
      />
      <circle
        cx="460"
        cy="250"
        r="28"
        fill="var(--primary-color, #02026E)"
        fillOpacity="0.12"
      />
      <circle
        cx="430"
        cy="250"
        r="28"
        fill="var(--primary-color, #02026E)"
        fillOpacity="0.08"
      />
    </g>

    <circle
      cx="720"
      cy="540"
      r="150"
      fill="none"
      stroke="var(--primary-color, #02026E)"
      strokeOpacity="0.12"
      strokeWidth="2"
    />
    <circle
      cx="720"
      cy="540"
      r="210"
      fill="none"
      stroke="var(--primary-color, #02026E)"
      strokeOpacity="0.08"
      strokeWidth="2"
    />
  </svg>
);

export default LoginVisualSvg;
